<panel>
  <div class="center" *ngIf="loadingPreferences">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
  <ul class="preferences" *ngIf="!loadingPreferences">
    <li>
      <preference [label]="'Language' | translate | async">
        <select class="select" [ngModel]="getCurrentSelectedLang" (change)="updateLanguage($event.target.value)">
          <option *ngFor="let l of languages" [value]="l.Id">{{l.Name}}</option>
        </select>
        <div class="info-message" *ngIf="languageWasChanged">
          Please refresh the page to see this change
        </div>
      </preference>
    </li>
    <li>
      <preference [label]="'Home Page' | translate | async">
        <select class="select" [ngModel]="dashboardDefaultView" (change)="updateHomePage($event.target.value)">
          <option value="0" *ngIf="hasUCSystemAcess==true">{{'UC Dashboard - Fleet Overview' | translate | async}}</option>
          <option value="1" *ngIf="hasUCSystemAcess==true">{{'UC Dashboard - Component Overview' | translate | async}}</option>
          <option value="2" *ngIf="hasUCSystemAcess==true">{{'UC Dashboard - Wear Rate Overview' | translate | async}}</option>

          <option value="3" *ngIf="hasGETSystemAcess==true">{{'GET Dashboard' | translate | async}}</option>
          <option value="4" *ngIf="hasGETSystemAcess==true">{{'CRC Dashboard' | translate | async}}</option>
          <option value="5" *ngIf="isSafetyInspector==true || hasSafetySystemAcess==true">{{'Safety Dashboard' | translate | async}}</option>
          <option value="6" *ngIf="hasGETSystemAcess==true">{{'Search Digital Forms' | translate | async}}</option>


        </select>
      </preference>
    </li>
    <li>
      <preference [label]="'Undercarriage User Type' | translate | async">
        <select class="select" [ngModel]="p.DeafultUCSetupType" (change)="UpdateUCSetupType($event.target.value)">
          <option value="1">{{'Advanced' | translate | async}}</option>
          <option value="2">{{'Basic' | translate | async}}</option>
        </select>
      </preference>
    </li>
    <li>
      <preference [label]="'UC Dashboard Settings' | translate | async">

        <mat-form-field style="width: 225px;">
          <mat-select multiple [(ngModel)]="dashboardFleetPreferneceView" (selectionChange)="UpdateDefaultDashboardFleetPref()"
                      style="min-width: 260px; height: 40px;
            display: inline !important; border: 1px solid #DfE7EF; color: #1D2F36; min-height: 40px; padding: 8px 16px;">
            <mat-option *ngFor="let column of DashboardFleetprefernceList" [value]="column.TaskID">{{column.TaskName}}</mat-option>
          </mat-select>
        </mat-form-field>


      </preference>
    </li>
    <li>
      <preference [label]="'UC Equipment Detail Settings' | translate | async" [description]="'* Applicable to Advanced users only' | translate | async">
        <mat-form-field style="width: 225px;">
          <mat-select multiple [(ngModel)]="dashboardPreferneceView" (selectionChange)="savePreferences($event)"
                      style="min-width: 260px; height: 40px; display: inline !important; border: 1px solid #DfE7EF;
                      color: #1D2F36; min-height: 40px; padding: 8px 16px;">
            <mat-option *ngFor="let column of DashboardPrefernceList" [value]="column.GridId">{{column.ColumnDisplayName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </preference>
    </li>
    <li>
      <preference [label]="'UC Component Inspection Order' | translate | async">
        <div class="divflex">
          <div>
            <select class="select" [ngModel]="p.UCCompInspectOrderOptionId" (change)="UpdateUCComponentInspectionOrderOption($event.target.value)" [disabled]="p.DeafultUCSetupType == 2? true: false">
              <option value="1">{{'Standard' | translate | async}}</option>
              <option value="2">{{'Custom' | translate | async}}</option>
            </select>
          </div>
          <div style="align-self: flex-end; height: 30px;">
            &nbsp;&nbsp;<a *ngIf="p.UCCompInspectOrderOptionId == 2 && p.DeafultUCSetupType == 1" href="javascript:void(0);" title="Click to edit UC Component Inspection Order" (click)="openComponentInspectionOrderPopup(false)"><mat-icon>create</mat-icon></a>
          </div>
        </div>

      </preference>
    </li>
    <li>
      <preference [label]="'UC Multiple Measurements' | translate | async">
        <div class="divflex">
          <div>
            <select class="select" [ngModel]="p.UCMultipleMeasurements" (change)="UpdateUCMultipleMeasurements($event.target.value)" [disabled]="p.DeafultUCSetupType == 2? true: false">
              <option value="true">{{'ON' | translate | async}}</option>
              <option value="false">{{'OFF' | translate | async}}</option>
            </select>
          </div>
          <div style="align-self: flex-end; height: 30px;">
            &nbsp;&nbsp;<a *ngIf="p.UCMultipleMeasurements == true && p.DeafultUCSetupType == 1" href="javascript:void(0);" title="Click to edit UC Multiple Measurements" (click)="openComponentInspectionOrderPopup(true)"><mat-icon>create</mat-icon></a>
          </div>
        </div>

      </preference>
    </li>
    <li>
      <preference [label]="'UC Equipment Conditions' | translate | async">
        <select class="select" [ngModel]="p.UCEquipmentCondition" (change)="UpdateEqCondition($event.target.value)" [disabled]="p.DeafultUCSetupType == 2? true: false">
          <option value="1">{{'Hide' | translate | async}}</option>
          <option value="2">{{'Show' | translate | async}}</option>
        </select>
      </preference>
    </li>

    <li>
      <!-- UCEquipmentConditionPage -->
      <preference [label]="'UC Inspection & Jobsite Comments Display' | translate | async">
        <select class="select" [ngModel]="p.UCEquipmentConditionPage" (change)="UpdateEqConditionPage($event.target.value)" [disabled]="p.DeafultUCSetupType == 2? true: false">
          <option value="1">{{'Equipment Conditions Page' | translate | async}}</option>
          <option value="2">{{'Equipment Details Page' | translate | async}}</option>
        </select>
      </preference>
    </li>
    <!-- TT-9543 -->
    <li>
      <preference [label]="'Undercarriage Forecast - % Worn Today' | translate | async">
        <div class="divflex">
          <div>
            <select class="select" [ngModel]="p.UCShowWornPerToday" (change)="UpdateUCForecastWornToday($event.target.value)" [disabled]="p.DeafultUCSetupType == 2? true: false">
              <option value="true">{{'ON' | translate | async}}</option>
              <option value="false">{{'OFF' | translate | async}}</option>
            </select>
          </div>
        </div>

      </preference>
    </li>
    <li>
      <preference [label]="'Default Form Type' | translate | async">
        <select class="select" [ngModel]="p.DefaultFormCatId" (change)="UpdateDefaultCat($event.target.value)">
          <option *ngFor="let form of formCatList" [value]="form.Id">{{form.Name}}</option>
        </select>
      </preference>
    </li>
    <li>
      <preference [label]="'Include Maintenance as Last Inspection' | translate | async">
        <mat-checkbox [(ngModel)]="IncludeMaintenanceLastInspect" (click)="ChangeIncludeMaintenanceLastInspect($event.target)"></mat-checkbox>
        <span class="div-incld-maint-insp-last">Includes maintenance inspections when determining the last inspection date and SMU on the Fleet Dashboard.</span>
      </preference>
    </li>
    <li>
      <preference [label]="'Display Maintenance Inspection' | translate | async">
        <mat-checkbox [(ngModel)]="ShowMaintenanceInsp" (click)="ChangeShowMaintenanceInsp($event.target)"></mat-checkbox>
      </preference>
    </li>
    <!-- TT-5439 -->
    <li>
      <preference [label]="'GET Dashboard Tasks Show/Hide' | translate | async">

        <mat-form-field style="width: 225px;">
          <mat-select multiple [(ngModel)]="dashboardTasksPreferneceView" (selectionChange)="UpdateDefaultTaskPref()"
                      style="min-width: 260px; height: 40px;
          display: inline !important; border: 1px solid #DfE7EF; color: #1D2F36; min-height: 40px; padding: 8px 16px;">
            <mat-option *ngFor="let task of prefernceList" [value]="task.TaskID">{{task.TaskName}}</mat-option>
          </mat-select>
        </mat-form-field>


      </preference>
    </li>
    <li>
      <preference [label]="'Enable Replace Existing tab' | translate | async">
        <mat-checkbox [(ngModel)]="ShowEnableReplaceExistingTab" (click)="UpdateEnableReplaceExistingTab($event.target)"></mat-checkbox>
      </preference>
    </li>
    <li>
      <preference [label]="'Currency' | translate | async">
        <select class="select" [ngModel]="p.CurrencyId" (change)="updateCurrency($event.target.value)">
          <option *ngFor="let c of currencies" [value]="c.Id">{{c.Name}} ({{c.Code}})</option>
        </select>
      </preference>
    </li>
    <li>
      <preference [label]="'Unit of Measurement' | translate | async" [description]="'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ' | translate | async">
        <select class="select" [ngModel]="p.UnitOfMeasurementName" (change)="updateUom($event.target.value)">
          <option value="mm">{{'Millimetres (mm)' | translate | async}}</option>
          <option value="inch">{{'Inches (inch)' | translate | async}}</option>
        </select>
      </preference>
    </li>
    <li>
      <preference [label]="'Distance Unit' | translate | async">
        <select class="select" [ngModel]="p.UnitofDistance" (change)="updateUoD($event.target.value)">
          <option value="km">{{'Kilometers (km)' | translate | async}}</option>
          <option value="mi">{{'Miles (mi)' | translate | async}}</option>
        </select>
      </preference>
    </li>


    <li>
      <preference [label]="'Contact' | translate | async">
        <ul class="items">
          <li class="item">
            <item [label]="'Full Name' | translate | async" [loading]="false">
              <click-to-edit-text [data]="p.FullName | aesDecrypt" (dataChanged)="updateFullName($event)"></click-to-edit-text>
            </item>
          </li>
          <li class="item">
            <item [label]="'Phone Number' | translate | async" [loading]="false">
              <click-to-edit-text [data]="p.PhoneNumber | aesDecrypt" (dataChanged)="updatePhoneNumber($event)"></click-to-edit-text>
            </item>
          </li>
        </ul>
      </preference>
    </li>
    <li>
      <preference [label]="'Address' | translate | async">
        <ul class="items">
          <li class="item">
            <item [label]="'Street Address' | translate | async" [loading]="false">
              <click-to-edit-text [data]="p.StreetAddress | aesDecrypt" (dataChanged)="updateStreetAddress($event)"></click-to-edit-text>
            </item>
          </li>
          <li class="item">
            <item [label]="'Suburb / City' | translate | async" [loading]="false">
              <click-to-edit-text [data]="p.Suburb | aesDecrypt" (dataChanged)="updateSuburb($event)"></click-to-edit-text>
            </item>
          </li>
          <li class="item">
            <item [label]="'Post Code' | translate | async" [loading]="false">
              <click-to-edit-text [data]="p.PostCode | aesDecrypt" (dataChanged)="updatePostCode($event)"></click-to-edit-text>
            </item>
          </li>
          <li class="item">
            <item [label]="'State' | translate | async" [loading]="false">
              <click-to-edit-text [data]="p.State | aesDecrypt" (dataChanged)="updateState($event)"></click-to-edit-text>
            </item>
          </li>
          <li class="item">
            <item [label]="'Country' | translate | async" [loading]="false">
              <click-to-edit-text [data]="p.Country" (dataChanged)="updateCountry($event)"></click-to-edit-text>
            </item>
          </li>
        </ul>
      </preference>
    </li>
  </ul>
</panel>
